import styled from '@emotion/styled';
import { IPAD_MEDIA } from '../media';
import { SurfaceWidget } from './SurfaceWidget';

export const ContentSurfaceWidget = styled(SurfaceWidget)`
  padding: 30px 32px 38px;
  ${IPAD_MEDIA} {
    padding: 24px 20px 30px;
    border-radius: 18px;
  }
`;
